import Image from "next/image";
import { ReactNode } from "react";
export default function PlayerError(): ReactNode {
  return <>
            <div>
                <div className="d-flex flex-column justify-content-center align-items-center dvh-100 overflow-y-auto gradient-bg">
                    <div className="container-xxl">

                        <div className="row justify-content-center align-items-center">
                            <div className="col-6 text-center h-100">

                                <Image className="fill-white" src="/svg/illustrations/ill-7.svg" alt="..." width={536} height={368} data-sentry-element="Image" data-sentry-source-file="PlayerError.tsx" />

                                <p className="lead lh-relaxed text-dark">
                                    Sorry, something went wrong.</p>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>;
}